import { render, staticRenderFns } from "./GalleryDetail.vue?vue&type=template&id=e122512e&scoped=true&"
import script from "./GalleryDetail.vue?vue&type=script&lang=js&"
export * from "./GalleryDetail.vue?vue&type=script&lang=js&"
import style0 from "./GalleryDetail.vue?vue&type=style&index=0&id=e122512e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e122512e",
  null
  
)

export default component.exports